import { z } from 'zod';
import { PostCreditHistoriesRequestBody } from '@/src/apis/rest/creditHistory.dtos';
import { CreditHistoryType } from '@/src/models/CreditHistoryDto';

export const DEFAULT_VALUES: PostCreditHistoriesRequestBody = {
  nick: '',
  currentCredit: '0',
  administrator: '',
  category: '관리자 지정',
  type: '적립',
  creditTemplateId: 0,
  description: null,
  subDescription: '',
  customerId: 0,
};

export const formSchema = () => {
  return z
    .object({
      creditTemplateId: z.number().optional(),
      value: z.number().optional(),
      description: z.string().min(1, '크레딧 지급/차감 사유를 입력해주세요.'),
    })
    .refine(data => {
      return data.creditTemplateId || data.value;
    });
};

export const formFields = {
  nick: {
    name: 'nick',
    label: '닉네임',
  },
  currentCredit: {
    name: 'currentCredit',
    label: '보유 크레딧',
  },
  type: {
    name: 'type',
    label: '크레딧 지급/차감',
  },
  creditTemplateId: {
    name: 'creditTemplateId',
    label: '지급/차감 크레딧',
    placeholder: '크레딧 카테고리 선택',
  },
  value: {
    name: 'value',
    label: '크레딧 급액 입력',
    placeholder: '지급할 크레딧 금액을 입력해주세요.',
  },
  subDescription: {
    name: 'subDescription',
    label: '크레딧 지급/차감 사유',
    placeholder: '크레딧를 지급/차감하는 사유를 입력해주세요',
  },
  administrator: {
    label: '담당 관리자',
    name: 'administrator',
  },
} as const;

export const creditTypeOptions: { label: string; value: CreditHistoryType }[] =
  [
    { label: '크레딧 지급', value: '적립' },
    { label: '크레딧 차감', value: '차감' },
  ];
